import React from "react";
import s from "../format/form.module.css"

export const Input = ({input,meta,...props}) => {
    const hasError = meta.touched && meta.error
    return <div className={s.formControl}>
        <input className={hasError ? s.formError : s.formControl} {...input} {...props} />
        {hasError && <span style={{fontSize: "14px",color:"#ffffff"}}>{meta.error}</span>}
    </div>
}
